import { match } from 'path-to-regexp';

type RouteMatchResult = {
    page: string;
    params: Record<string, string>;
};

const cache: Map<string, RouteMatchResult> = new Map();

export function getRouteFromPathname(
    pathname: string,
    navigationSlugs: Record<string, string>
): RouteMatchResult {
    if (cache.has(pathname)) {
        return cache.get(pathname)!;
    }

    const result = getRouteFromPathnameWithoutCache(pathname, navigationSlugs);
    cache.set(pathname, result);

    return result;
}

export function getRouteFromPathnameWithoutCache(
    pathname: string,
    navigationSlugs: Record<string, string>
): RouteMatchResult {
    let result = { page: '', params: {} };
    for (const routeId in navigationSlugs) {
        const route = navigationSlugs?.[routeId];
        const matcher = match(route, { decode: decodeURIComponent });
        const matchMaybe = matcher(pathname);

        if (matchMaybe) {
            result = {
                page: routeId,
                params: (matchMaybe?.params as Record<string, string>) ?? {}
            };
            break;
        }
    }

    return result;
}
